import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M43.691667,45.15 L50.691667,61 L44.291667,61 L38.291667,47 L33.591667,47 L33.591667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 43.691667,45.15 Z M33.591667,42.2 L39.241667,42.2 C42.791667,42.2 44.691667,40.85 44.691667,37.95 C44.691667,35.05 42.791667,33.8 39.241667,33.8 L33.591667,33.8 L33.591667,42.2 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
